
import { Heart } from 'lucide-react';

export const LocalFavoritesEmptyState = () => {
  return (
    <div className="container mx-auto px-4 mb-8">
      <div className="bg-gradient-to-r from-gray-50 to-gray-100 border border-gray-200 rounded-lg p-4">
        <div className="text-center text-gray-600">
          <Heart className="h-5 w-5 mx-auto mb-2 text-gray-400" />
          <p>Geen favorieten opgeslagen</p>
          <p className="text-xs mt-1">Klik op het hartje bij een vakantie om hem toe te voegen</p>
        </div>
      </div>
    </div>
  );
};
